module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan4-2-f60c348dacf7e7a3e7fe4cc86ae3f43a.webp";